module.exports = __webpack_public_path__ + "static/img/sy-btcheck.e2b20643.svg";